/**
 * ID Badge Title Controller
 *
 * Adds required styling to the primary title of id-badges.
 */
class IdBadgeTitleController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    this._$attrs.$addClass('vd-id-badge__header-title')
  }
}

export default IdBadgeTitleController
